import { Box, EmptyState, TextButton } from '@wix/design-system';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { RELATED_ITEM_HEIGHT } from '../constants';

type RelatedItemsErrorStateProps = {
  onRefresh: () => void;
};

export const RelatedItemsErrorState: FC<RelatedItemsErrorStateProps> = ({ onRefresh }) => {
  return (
    <Box height={RELATED_ITEM_HEIGHT} WebkitAlignItems="center" WebkitJustifyContent="center">
      <EmptyState
        align="center"
        skin="section"
        title={<FormattedMessage id="empty-state.related-images-error-title" />}
        subtitle={<FormattedMessage id="empty-state.related-images-error-subtitle" />}
      >
        <TextButton onClick={onRefresh}>
          <FormattedMessage id="empty-state.related-images-error-cta" />
        </TextButton>
      </EmptyState>
    </Box>
  );
};
